// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CaretLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/CaretLeftOutlined";
import AntdIcon from '../components/AntdIcon';

var CaretLeftOutlined = function CaretLeftOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CaretLeftOutlinedSvg
  }));
};

CaretLeftOutlined.displayName = 'CaretLeftOutlined';
export default React.forwardRef(CaretLeftOutlined);